module.exports = __webpack_public_path__ + "static/img/banner_news_1.d03295e.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/newInfo/banner_news_1.png
// module id = eS9D
// module chunks = 0